export default __webpack_public_path__ + "static/akuity-logo.b66a3328.svg";